import { registerSW } from 'virtual:pwa-register';

interface CapacitorGlobal {
  isNativePlatform?: () => boolean;
}

export function setupServiceWorker(): void {
  const capacitor = (window as unknown as { Capacitor?: CapacitorGlobal }).Capacitor;
  if (capacitor?.isNativePlatform?.()) {
    return;
  }
  registerSW({ immediate: true });
}
